import React, {useState, useEffect, useContext} from 'react';
import { Header } from './';
import { Pagination } from '../components';
import moment from 'moment';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { DashboardMenu } from '../components';
import { SiteContext } from '../context';
import ReactModal from 'react-modal';

const FaqsCategory = () => {

  let navigate = useNavigate();
  let location = useLocation();

  let cat = location.state;

const { apiUrl, userData } = useContext(SiteContext);

const [faqs, setFaqs] = useState([]);
const [total, setTotal] = useState(null);
const [limit, setLimit] = useState(10);
const [page, setPage] = useState(1);
const [cangoBack, setCangoBack] = useState(true);
const [cangoForward, setCangoForward] = useState(true);
const [updateItem, setUpdateItem] = useState({});
const [itemSelected, setItemSelected] = useState('');
const [msg, setMsg] = useState('');
const [errorMsg, setErrorMsg] = useState('');
const [showModal, setShowModal] = useState(false);

useEffect(() => {
  getFaqs();
},[page,limit,cat])

const getFaqs = () => {

  let formData = new FormData();

  formData.append('cat', cat);
  formData.append('page', page);
  formData.append('limit', limit);
  formData.append('action', 'fetchfaqscat');

  fetch(`${apiUrl}/api/faqs.php`, {
    method:'post',
    body: formData
  }).then((res) => {
      return res.json()
  }).then((res) => {
    if(res.status === 200) {
      if(res.rows.length > 0) {
        setFaqs(res.rows);
        setTotal(res.count);      
    }
      } else if (res.status === 400) {
          setMsg(res.msg)
          setTimeout(() => {
            setMsg('')
          },3000)
      }
  }).catch((err) => {
      console.log(err)
  })
}

const doPrevious = async () => {
 
  if(parseInt(page) > 1) {
    await setPage(() => parseInt(page - 1));
    setCangoBack(true);
    setCangoForward(true);
  } else {
    setCangoBack(false);
    setCangoForward(true);
  }
}

const doNext = async () => {

  if(parseInt(page * limit) < total) { 
    await setPage(() => parseInt(page + 1));
    setCangoForward(true);
    setCangoBack(true);
  } else {
    setCangoForward(false);
    setCangoBack(true);
  }
}

const handleChange = (event) => {
  let newLimit = event.target.value;
  setLimit(newLimit);
}

const handleShow = (faq) => {
  setItemSelected(faq);
  setShowModal(true);
}



    return (
        <div>
            <ReactModal
      isOpen={showModal}
      ariaHideApp={false}
      style={{
        overlay: {
          flex:1,
          justifyContent: 'center',
          alignContent: 'center',
          position: 'fixed',
          top: 0,
          bottom: '5%',
          left: '5%',
          right: '5%',
          width: '90%',
          height: '50%',
          backgroundColor: 'rgba(255, 255, 255, 0.75)'
        },
        content: {
          position: 'absolute',
          top: '10px',
          left: '10px',
          right: '10px',
          bottom: '10px',
          border: '1px solid #ccc',
          background: '#fff',
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          borderRadius: '4px',
          outline: 'none',
          padding: '20px'
        }
      }}>
        <div>
        <span className='btn btn-secondary' onClick={() => setShowModal(false)}>x</span>
          <p className='h3 my-1 py-1'>{itemSelected.faqquestion}</p>
          <p className='my-1 py-2'>{itemSelected.faqanswer}</p>
        </div>
      </ReactModal>
            <div>
                <div className='container'>

                <h3>Frequently Asked Questions</h3>

                <div className='my-2 d-flex justify-content-between'>
                  <div className='align-items-center'>
                  {msg !== '' ? <div className='p-2'><span className='p-2 border border-info text-dark'>{msg}</span></div> : null}
                {errorMsg !== '' ? <div className='p-2'><span className='p-2 border border-info text-dark'>{errorMsg}</span></div> : null}
                  </div>
                </div>

        {faqs.length > 0 && <Pagination limit={limit} page={page} total={total} cangoBack={cangoBack} cangoForward={cangoForward} handleChange={handleChange} doNext={doNext} doPrevious={doPrevious} />}

          {faqs && faqs.map((faq,i) => {
            return (
              <div key={faq.faqid}>
                <div className='bg-light h4 p-2'>
                <button className='w-100 text-decoration-none border-0 bg-transparent' onClick={() => handleShow(faq)}>
                  <div className='d-flex justify-content-between'>
                    <div className='p-2'>
                      {faq.faqquestion} <br />
                      <span className='text-muted small float-start'>{faq.faqcat}</span>
                    </div>
                    <div className='p-2'>
                      <i className='bi bi-plus'></i>
                    </div>
                  </div>
                </button>
                </div>
            </div>

              )
          })}

              </div>
            </div>
        </div>

    )
}

export default FaqsCategory;